import { TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const USER_EMAIL_SETTING_KEY = "user-email-setting";

export interface UserEmailSettingResponse {
  defaultEmailAccountId: string | null;
  signature: string | null;
}

// Returned when the server responds with an empty body (e.g. a PUT that echoes
// nothing). Keeps callers — and the query cache — from ever seeing `undefined`.
const emptyUserEmailSetting = (): UserEmailSettingResponse => ({
  defaultEmailAccountId: null,
  signature: null,
});

export interface UpsertUserEmailSettingRequest {
  /** Signature HTML. Send null to clear, omit to leave unchanged. */
  signature?: string | null;
  /** InstalledIntegration id of the default mailbox. null clears it. */
  defaultEmailAccountId?: string | null;
}

export const getUserEmailSetting =
  async (): Promise<UserEmailSettingResponse> => {
    try {
      const response = await http.get<UserEmailSettingResponse>(
        links.userEmailSetting.index,
      );
      return response.data || emptyUserEmailSetting();
    } catch (error) {
      throw error as TServerErrorResponse;
    }
  };

export const upsertUserEmailSetting = async (
  body: UpsertUserEmailSettingRequest,
): Promise<UserEmailSettingResponse> => {
  try {
    const response = await http.put<UserEmailSettingResponse>(
      links.userEmailSetting.index,
      body,
    );
    return response.data || emptyUserEmailSetting();
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
